import { defineComponent as _defineComponent } from 'vue'
import { computed, shallowRef, triggerRef } from 'vue';

import { handleClickoutUrl, isClickoutUrl, UrlHelper, trackClickout } from '@/helpers/clickout-helper';
import { ClickoutType } from '@/interfaces/snowplow/clickout-context';
import { useApolloClient } from '@/graphql/apollo';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClickoutAnchor',
  props: {
    href: null,
    rel: { default: 'noopener' },
    skipPreAffiliationCheck: { type: Boolean },
    clickoutType: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'click', event: MouseEvent): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { href: UrlHelper, rel: string, skipPreAffiliationCheck?: boolean, clickoutType?: ClickoutType };





const enableSkipUct = computed(() => false);

const CLICK_MASKED_SHORTNAMES = ['tbv'];
const linkRel = computed(() =>
	isClickoutUrl(props.href) && CLICK_MASKED_SHORTNAMES.includes(props.href.shortName ?? '')
		? `${props.rel ?? ''} noreferrer`
		: props.rel
);

/**
 * We create the reacitiveKey to trigger reactivity updates when the ClickoutUrl changes.
 * The setTriggerRef function is used to trigger reactivity when the contexts update.
 * This is necessary because Vue's reactivity system does not automatically track changes in class instances.
 */
const reactiveKey = shallowRef(null);

/**
 * reactiveUrl returns a computed property that reacts to updates in the ClickoutUrl.
 */
const reactiveUrl = computed(() => {
	if (!isClickoutUrl(props.href)) return props.href;

	// watch for changes to the key from updates to the ClickoutUrl
	reactiveKey.value;

	// set the triggerRef to update the reactive state when certain ClickoutUrl properties change
	return props.href.setTriggerRef(updateReactiveKey);
});

// The non-UCT, non-adblockable link that is allowed in the HTML.
// Fallback to the UCT link so that worst case there's still something.
const offerUrl = computed(() => {
	if (enableSkipUct.value) {
		if (isClickoutUrl(reactiveUrl.value) && reactiveUrl.value.preAffiliatedUrl) {
			return reactiveUrl.value.preAffiliatedUrl;
		}
		return reactiveUrl.value.get('r') ?? reactiveUrl.value.toString();
	}

	// return the directly affiliated link
	return reactiveUrl.value.toString();
});

const client = useApolloClient();

function onClickout(event: MouseEvent) {
	emits('click', event);

	if (!enableSkipUct.value) {
		if (isClickoutUrl(reactiveUrl.value)) {
			trackClickout(reactiveUrl.value);
		}
		return;
	}

	// Skip UCT is active, prevent default <a> behavior and take over with our `handleClickoutUrl` logic
	event.preventDefault();

	handleClickoutUrl(reactiveUrl.value, client, enableSkipUct.value, !props.skipPreAffiliationCheck);
}

/**
 * The function passed to ClickoutUrl.setTriggerRef to update the reactiveKey.
 * this function does not work inline, but is stable when declared
 * triggerRef is used to trigger reactivity updates in Vue, without the need to update the value of the shallowRef directly.
 *
 */
function updateReactiveKey() {
	triggerRef(reactiveKey);
}

return { __sfc: true,props, emits, enableSkipUct, CLICK_MASKED_SHORTNAMES, linkRel, reactiveKey, reactiveUrl, offerUrl, client, onClickout, updateReactiveKey }
}

})